import { atom } from 'recoil'

const getObjectFromStorage = async (key, defaultObject) => {
  const volumeSettings = window.localStorage.getItem(key)
  try {
    return volumeSettings ? JSON.parse(volumeSettings) : defaultObject
  } catch (error) {
    return {}
  }
}
const updateObjectInStorage = (key) => ({onSet}) => {
  onSet((newValue) => {
    window.localStorage.setItem(key, JSON.stringify(newValue))
  })
}
const getStringFromStorage = async (key) => {
  return window.localStorage.getItem(key) || ''

}
const updateStringInStorage = (key) => ({onSet}) => {
  onSet((newValue) => {
    window.localStorage.setItem(key, newValue)
  })
}

// export const authState = atom({
//     key: 'auth-state',
//     default: {
//         userEmail: '',
//     },
// })

export const authState = atom({
  key: 'auth-state',
  default: {
    user: {},
  },
})

export const selectedRegionState = atom({
    key: 'selected-region',
    default: getStringFromStorage('selected-region'),
    effects:[updateStringInStorage('selected-region')]
})
export const selectedCountryState = atom({
    key: 'selected-country',
    default: getStringFromStorage('selected-country'),
    effects:[updateStringInStorage('selected-country')]
})
export const selectedStoreState = atom({
    key: 'selected-store',
    default: getStringFromStorage('selected-store'),
    effects:[updateStringInStorage('selected-store')]
})
export const selectedTabletState = atom({
    key: 'selected-tablet',
    default: getStringFromStorage('selected-tablet'),
    effects:[updateStringInStorage('selected-tablet')]
})
export const selectedDashboardGroupingState = atom({
    key: 'selected-dashboard-grouping',
    default: getObjectFromStorage('selected-dashboard-grouping', {
      type: '',
      key: ''
    }),
    effects:[updateObjectInStorage('selected-dashboard-grouping')]
})
export const starredTabletsState = atom({
    key: 'starred-tablets',
    default: getObjectFromStorage('starred-tablets', []),
    effects:[updateObjectInStorage('starred-tablets')]
})


export const logPanelVisibleState = atom({
  key: 'log-panel',
  default: {open: false, tablet: {}}
})